// extracted by mini-css-extract-plugin
module.exports =  {"fieldset":"gWMGDuh2wbqfrXxEcLGQ","donationFormsSelect":"DD60K7FcXmolHk47JmHT"};